export default {
  apiStateSyncPeriodSeconds: parseInt(process.env.VUE_APP_APISTATE_SYNC_PERIOD_SECONDS) || 120,
  contractsSyncPeriodSeconds: parseInt(process.env.VUE_APP_CONTRACTS_SYNC_PERIOD_SECONDS) || 60
}